import {Button} from 'gf-ui-components-mui-lib';
import { PlusBtn } from '@/icons';


// +create new (page) btn without transition
const CreateFormbtns = ({ onClick, children }: any) => {
  return (
    <Button
      sx={{
        display: 'flex',
        padding: '12px',
        background: '#2469F3',
        height: '48px',
        color: ' #FFF',
        fontSize: '14px',
        fontFamily: 'Inter',
        fontWeight: 500,
        lineHeight: '24px',
        border: '1px gray #E6E6E6',
        ':hover': {
          background: '#2469F3'
        }
      }}
      onClick={onClick}
      startIcon={<PlusBtn />}
      children={children}
      className="create-form-btn"
    />
  );
};
export default CreateFormbtns;
